export default "__VITE_ASSET__B0W8ksUN__"